<template>
  <div class="support-service">
    <div class="inner">
      <div class="title">
        全行业最强推广支持
      </div>
      <div class="subtitle">
        THE MOST POWERFUL PROMOTION SUPPOERT
      </div>
      <div class="bar" />
      <div class="services">
        <div class="serv-boxes">
          <div class="serv-box" v-for="(c, i) in servlist" :key="i">
            <div class="serv-card">
              <div class="servicon">
                <img :src="require(`../../assets/images/${c.icon}.png`)">
              </div>
              <div class="card-title">{{ c.title }}</div>
              <div class="card-subtitle">{{ c.subtitle }}</div>
              <div class="divider" />
              <div class="desc">{{ c.sub }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'

const servlist = ref([
  {
    icon: 'supp1',
    title: '支持全渠道推广',
    subtitle: 'Omnichannel promotion',
    sub:
      '提供全面丰富的图片、视频推广素材，专业定制马甲包，支持分发全网每个角落',
  },
  {
    icon: 'supp2',
    title: '15天成为推广达人',
    subtitle: 'Become a promoter in 15 days',
    sub: '专家团队24小时提供专业指导，零基础也可快速成为推广达人',
  },
  {
    icon: 'supp3',
    title: '最全数据报表',
    subtitle: 'Data report',
    sub: '全面分析佣金组成、会员游戏状况，对您的会员了如指掌',
  },
])
</script>
<style lang="scss">
.support-service {
  background: url('../../assets/images/login/cus-bg.png');
  width: 100%;
  height: 100vh;
  font-family: 'PingFang SC', sans-serif;
  .inner {
    width: 100%;
    max-width: 1280px;
    height: 100%;
    margin: 0 auto;
    padding: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .title {
    color: #333333;
    font-size: clamp(1.4rem, 5vh, 2.25rem);
    font-weight: bold;
  }
  .subtitle {
    color: #1b3d63;
    font-size: clamp(0.8rem, 2.2vh, 1.3rem);
    font-weight: 500;
    margin-top: clamp(6px, 1.5vh, 14px);
  }
  .bar {
    width: 100%;
    max-width: 600px;
    height: 4px;
    margin-top: 14px;
    background: linear-gradient(
      90deg,
      #33b5ff 0%,
      rgba(26, 173, 255, 0) 101.54%
    );
  }
  .services {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 32px auto 0;
    align-items: center;
    min-height: 0;
    .serv-boxes {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      gap: 14px;
    }
    .serv-box {
      width: 100%;
      flex: 1;
      min-height: 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      text-align: center;
      .serv-card {
        width: 100%;
        height: 100%;
        min-height: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: clamp(2px, 0.8vh, 8px);
        background: #e3efff;
        border-radius: 16px;
        padding: clamp(6px, 1.6vh, 16px) 24px;
        overflow: hidden;
        box-sizing: border-box;
        .servicon {
          width: clamp(28px, 8vh, 90px);
          margin-bottom: clamp(2px, 0.6vh, 4px);
          flex-shrink: 0;
          img {
            width: 100%;
            display: block;
          }
        }
        .card-title {
          color: #1b3d63;
          font-weight: 600;
          font-size: clamp(0.85rem, 2.4vh, 1.2rem);
          flex-shrink: 0;
        }
        .card-subtitle {
          color: #767883;
          font-weight: 500;
          font-size: clamp(0.7rem, 1.8vh, 1rem);
          padding: 0 20px;
          flex-shrink: 0;
        }
        .divider {
          align-self: stretch;
          height: 1px;
          background: #ffffff;
          margin: clamp(4px, 1.2vh, 10px) 20px;
          flex-shrink: 0;
        }
        .desc {
          color: #767883;
          font-weight: 600;
          font-size: clamp(0.75rem, 1.8vh, 1rem);
          line-height: 1.4;
          padding: 0 20px;
          flex-shrink: 0;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .support-service {
    height: auto;
    .inner {
      height: auto;
      padding: 16px;
    }
    .title {
      font-size: 1.5rem;
    }
    .subtitle {
      font-size: 0.9rem;
    }
  }
}
@media (min-width: 769px) {
  .support-service {
    .services {
      .serv-boxes {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 1fr;
      }
      .serv-box:last-child {
        grid-column: 1 / -1;
      }
    }
  }
}
</style>
